import s from "./CTA.module.scss";

const CTA = ({
    variant = "default",
    text,
    href,
    icon = null,
}) => {

    let classNames = s.CTA;
    if (variant === "nobackground" || variant === "icon" || variant === "nobackwicon") classNames += ` ${s.nobackground}`;
    if (variant === "icon") classNames += ` ${s.withIcon}`;
    if (variant === "nobackwicon") classNames += ` ${s.nobackwicon}`;


    return (
        <a 
            href={href} 
            className={classNames} 
        >
            {(variant === "icon" || variant === "nobackwicon") && icon && (
                <span className={s.icon}>{icon}</span>
            )}
            {text}
            <span className={s.hoverEffect}></span>
        </a>
    );
};

export default CTA;
